module.exports = __webpack_public_path__ + "img/iwork-logo.51ec8ef8.png";